var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChanakyaLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4062 7.14204C23.7945 7.32055 24.1952 6.91979 24.0167 6.53153C23.4821 5.36852 23.4821 4.03057 24.0167 2.86757C24.1952 2.47931 23.7945 2.07855 23.4062 2.25706C22.2432 2.7917 20.9052 2.7917 19.7422 2.25706C19.354 2.07855 18.9532 2.47931 19.1317 2.86757C19.6664 4.03057 19.6664 5.36852 19.1317 6.53153C18.9532 6.91979 19.354 7.32055 19.7422 7.14204C20.9052 6.60739 22.2432 6.60739 23.4062 7.14204Z",
    fill: "url(#paint0_linear_6829_4327)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3667 25.4917C19.3986 24.2719 18.9367 22.6591 19.2264 21.0044L19.7636 17.9375C20.302 14.8645 18.247 11.9371 15.174 11.3986L14.9987 11.368L14.9681 11.1928C14.4297 8.11976 11.5022 6.06512 8.42921 6.60315L5.36233 7.1403C3.70761 7.43007 2.09484 6.9681 0.875 6",
    stroke: "url(#paint1_linear_6829_4327)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3667 25.4917L0.875 6",
    stroke: "url(#paint2_linear_6829_4327)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58691 19.7787L18.1634 8.20215",
    stroke: "url(#paint3_linear_6829_4327)",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6829_4327",
    x1: 23.1075,
    y1: -1.33864,
    x2: 29.4275,
    y2: 7.47876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4087FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531399,
    stopColor: "#9642EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA0CE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6829_4327",
    x1: 1.27867,
    y1: 0.0441979,
    x2: 32.6705,
    y2: 5.22324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4087FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531399,
    stopColor: "#9642EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA0CE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6829_4327",
    x1: 1.27867,
    y1: 0.0441979,
    x2: 32.6705,
    y2: 5.22324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4087FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531399,
    stopColor: "#9642EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA0CE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6829_4327",
    x1: 6.82666,
    y1: 4.66489,
    x2: 25.4709,
    y2: 7.74082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4087FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531399,
    stopColor: "#9642EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA0CE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanakyaLogo);
export default __webpack_public_path__ + "static/media/chanakya_logo.4e912a5a274edf8e79e83c48a10341af.svg";
export { ForwardRef as ReactComponent };